import React from "react";
import { connect } from "react-redux";
import styles from "../../widgets/DashboardComponents/V3/UserTotalWidget/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import styled from "styled-components";
import { gridStyle as gstyle, cellStyle as cstyle } from "../../reports/gridHelper";
import Avatar from "@material-ui/core/Avatar";
import CardContent from '@material-ui/core/CardContent';
import Paper from "@material-ui/core/Paper";
import {
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    Label,
    ModalHeader
} from "reactstrap";
import {
    StyledCard,
    StyledContent,
    StyledHeader,
} from "../../styles";
import {
    Typography,
    withStyles,
    Grid,
    Button,
    Card,
    TextField,
    List,
    ListItem,
    Table,
    TableBody,
    TableRow,
    Select,
    MenuItem,
    Divider
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import {
    getFeatures,
    setReportDetails,
    getTemplates,
    getArchieveTemplates,
    addGroup,
    getInspections,
    setDeleted,
    removeTemplate,
    addItem,
    editGroup,
    removeGroup,
    editItem,
    editItemIcon,
    getCopyTemplate,
    templateCopy
} from "./actions";
import {
    selectTemplate,
    getCustomInspections,
    getUserProfile,
    selectTemplateName,
    getSelectedTemplate,
    canUpdate,
    canCreate,
    canDelete,
    selectArchieveTemplateName
} from "./selectors";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Add as AddIcon, } from "@material-ui/icons";
import AddCircleIcon from '@material-ui/icons/AddCircle';
let refItem
const StyledListItem = styled(ListItem)`
    background: white;
    border: 1px solid #ddd;
    border-radius: 0px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    margin-top: 24px;
    border-left: 4px solid ${(props) => props.borderColor};
    :first & {
        margin-top: 0px;
    }
`;
const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;
const StyledAvatar = styled(Avatar)`
    height: 200px !important;
    width: 200px !important;
    margin: auto !important;
    border: 1px solid black !important;
`;
const InfoPaper = styled(Paper)`
    height: 80%;
    overflow: scroll;
`;
const InfoModal = styled(Modal)`
    width: 110vw;
    height: 80vh;
    margin-top: 10vh;
    margin-right: 15vw;
    margin-left: 15vw;
    margin-bottom: 10vh;
`;

const InfoDiv = styled.div`
    display: flex;
    justify-content: end;
    padding: 30px;
`;
class VehicleChecklistTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadImageLocal: false,
            month: moment().format("MMM").toLowerCase(),
            year: moment().format("YYYY").toLowerCase(),
            isTitleEntered: false,
            titleChangeModal: false,
            copyTitleName: "",
            newCopyName: "",
            copyTemplate: "",
            prevTitleName: "",
            isTemplateCreate: false,
            isCopyTemplate: false,
            isSection1: false,
            isSection2: false,
            newInspectionModal: false,
            editGroupModal: false,
            deleteGroupModal: false,
            editUID: "",
            newItemModal: false,
            editItemModal: false,
            // deleteItemModal: false,
            groupIdReference: 0,
            itemIdReference: 0,
            itemcount: 0,
            groupcount: 0,
            itemAddGroupName: "",
            itemAddGroupId: "",
            deleteTemplateModal: false,
            inspectionViewModal: false,
            warningModal: false,
            submitModal: false,
            template_details: {
                title: "",
                deleted: true,
                timestamp: ""
            },
            created_by: {
                user_uid: "",
                user_name: ""
            },
            new_group: {
                title: "",
                section_id: ""
            },
            new_item: {
                item_title: "",
                item_id: "",
                item_icon: ""
            }

        };
        props.getTemplates();
        props.getArchieveTemplates();
    }

    handleCloseModel = () => {
        this.setState({
            isTitleEntered: false,
            titleChangeModal: false,
            uploadImageLocal: false,
            month: moment().format("MMM").toLowerCase(),
            year: moment().format("YYYY").toLowerCase(),
            copyTemplate: "",
            copyTitleName: "",
            newCopyName: "",
            prevTitleName: "",
            isTemplateCreate: false,
            isCopyTemplate: false,
            isSection1: false,
            isSection2: false,
            newInspectionModal: false,
            editGroupModal: false,
            deleteGroupModal: false,
            editUID: "",
            newItemModal: false,
            editItemModal: false,
            groupIdReference: 0,
            itemIdReference: 0,
            itemcount: 0,
            groupcount: 0,
            itemAddGroupName: "",
            itemAddGroupId: "",
            deleteTemplateModal: false,
            inspectionViewModal: false,
            warningModal: false,
            submitModal: false,
            template_details: {
                title: "",
                deleted: true,
                timestamp: ""
            },
            new_group: {
                title: "",
                section_id: ""
            },
            new_item: {
                item_title: "",
                item_icon: "",
                item_id: ""
            },
            created_by: {
                user_uid: "",
                user_name: ""
            }
        });
    };

    handleNewInspectionModal = () => {
        this.setState({
            newInspectionModal: true,
            new_group: {
                title: "",
                section_id: ""
            }
        });
    };

    setId = (ref) => {
        let reference = ref
        let newGroup = this.state
            .new_group;
        newGroup.section_id =
            reference;
        this.setState({
            new_group: newGroup
        });
    }
    handleCount = (type, prevState) => {
        let count = prevState
        if (type === "add") {
            count = count + 1;
        }
        else {
            count = count - 1
        }
        this.setState({
            groupIdReference: count
        });
    }
    handleItemCount = (type, prevState) => {
        let count = prevState
        if (type === "add") {
            count = count + 1;
        }
        else {
            count = count - 1
        }
        this.setState({
            itemIdReference: count
        });
    }
    setItemId = (ref, item) => {
        let reference = ref

        let newItem = item;
        newItem.item_id =
            reference;
        this.setState({
            new_item: newItem
        });

    }
    render() {
        const { templates, inspections, userProfile, tempTitles, copyTemp, archieveTitles } = this.props
        const { classes } = this.props;
        let color = this.props.color;
        let name = userProfile.name
        let uid = userProfile.uid
        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5"><b>Walkaround Inspection Template</b></Typography>
                </StyledHeader>
                <StyledContent>
                    <div>
                        {this.props.canCreate && (
                            <Button
                                style={{
                                    width: "500px",
                                    marginLeft: "5px",
                                    backgroundColor: "#0188cc",
                                    float: "left"
                                }}
                                onClick={() => {
                                    this.setState({
                                        isTemplateCreate: true,
                                        isCopyTemplate: false
                                    });
                                }}
                            >
                                <b style={{ color: "white" }}> Create Template </b>
                            </Button>
                        )}
                        {this.props.canUpdate && (
                            <Button
                                style={{
                                    width: "500px",
                                    marginLeft: "50px",
                                    backgroundColor: "#0188cc",
                                    float: "left"
                                }}
                                onClick={() => {
                                    this.setState({ isCopyTemplate: true, isTemplateCreate: false });
                                }}
                            >
                                <b style={{ color: "white" }}> Copy Template </b>
                            </Button>
                        )}
                    </div>
                    {/* ------Copy Template---------- */}
                    {this.state.isCopyTemplate === true ?
                        <>
                            <Card className={classes.root}
                                style={{
                                    width: "615px",
                                    borderWidth: "medium",
                                    border: "7px solid #0188cc",
                                    borderRadius: "9px",
                                    marginLeft: "20px",
                                    marginTop: "70px",
                                    marginBottom: "10px"
                                }}
                            >
                                <CardContent>
                                    <Typography style={{ fontSize: "1.5em" }}>
                                        <b>Copy Template</b>
                                    </Typography>
                                    <br />
                                    <Label for="name">
                                        Select Existing Template&nbsp;:&nbsp;
                                    </Label>
                                    <Select
                                        value={this.state.copyTemplate}
                                        style={{ width: "150px" }}
                                        onChange={(event) => {
                                            this.setState({
                                                copyTemplate: event.target.value
                                            })
                                            this.props.getCopyTemplate(event.target.value, "inspection_checklist_templates")
                                        }}
                                    >
                                        {templates &&
                                            Object.values(templates).map((e) => {
                                                if (e.profile.deleted === false) {
                                                    return (
                                                        <MenuItem value={e.profile.title} >
                                                            {e.profile.title}
                                                        </MenuItem>
                                                    );
                                                }
                                                return null;
                                            })}
                                    </Select>
                                    <br />
                                    <br />
                                    <Label for="name">
                                        Enter New Template Name&nbsp;:&nbsp;&nbsp;
                                    </Label>
                                    <TextField
                                        multiline={false}
                                        style={{
                                            marginBottom: "11px",
                                            width: "100%"
                                        }}
                                        value={
                                            this.state.newCopyName
                                        }
                                        placeholder="Section Name"
                                        onChange={event => {
                                            if (
                                                tempTitles.includes(event.target.value) === true
                                            ) {
                                                this.setState({
                                                    warningModal: true,
                                                });
                                            }
                                            let newName = event.target.value;
                                            this.setState({
                                                newCopyName: newName
                                            });
                                        }}
                                    />
                                    <br />
                                    <br />
                                    <br />
                                    <Button
                                        disabled={this.state.newCopyName === "" ?
                                            true
                                            :
                                            false
                                        }
                                        onClick={() => {
                                            let newGroup = this.state
                                                .created_by;
                                            newGroup.user_uid = uid;
                                            newGroup.user_name = name
                                            this.setState({
                                                created_by: newGroup
                                            });
                                            this.props.templateCopy(this.state.newCopyName, copyTemp, this.state.created_by, "inspection_checklist_templates")
                                            this.handleCloseModel();
                                        }}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "#0288CC",
                                            marginLeft: "5px",
                                            marginBottom: "24px",
                                            color: "white"
                                        }}
                                    >
                                        Create Copy Template
                                    </Button>
                                    <Button

                                        onClick={() => {
                                            this.handleCloseModel();
                                        }}
                                        style={{
                                            width: "100%",
                                            backgroundColor: "#a9a5a5",
                                            marginLeft: "5px",
                                            marginBottom: "24px"
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </CardContent>
                            </Card>
                        </>
                        :
                        ""
                    }


                    {/* -----------Template View------------------------ */}

                    {this.state.isTemplateCreate === false && this.state.isCopyTemplate === false ?
                        <>
                            <br />
                            <br />
                            <br />
                            <div style={{ clear: "both", border: "2px solid #0188cc", borderRadius: "6px", marginLeft: "5px", marginTop: "10px" }}>
                                <h1 style={{
                                    backgroundColor: "#0188cc",
                                    textAlign: "center",
                                    padding: "4px",
                                    fontWeight: "bold",
                                    color: "white",
                                    fontSize: "22px"
                                }}>
                                    Inspection Templates
                                </h1>
                            </div>


                            <List style={{ background: "#eee" }}>
                                {templates && templates
                                    .map((template, index) => {

                                        return (
                                            template.profile.deleted === true ?
                                                ""
                                                :
                                                <StyledListItem
                                                    borderColor={"#0188cc"}
                                                    style={{
                                                        root: {
                                                            borderLeft: "#0188cc",
                                                        },
                                                    }}
                                                >
                                                    <Grid container spacing={4}>
                                                        <Grid item sm={12} md={12} lg={9} xl={9}>
                                                            <Typography
                                                                variant="body2"
                                                                style={{ paddingLeft: 24 }}
                                                            >
                                                                <h5 style={{ paddingTop: "12px" }}>
                                                                    <b>Template Name: </b>
                                                                    {template.profile.title}
                                                                </h5>

                                                            </Typography>
                                                        </Grid>
                                                        <Grid item sm={12} md={12} lg={3} xl={3} style={{ display: "flex", clear: "both", marginTop: "10px" }}>

                                                            <Button
                                                                style={{ backgroundColor: "#0188CC", color: "white", width: "250px", height: "45px" }}
                                                                variant="contained"
                                                                onClick={() => {
                                                                    this.props.getInspections(template.profile.title, "inspection_checklist_templates")
                                                                    this.setState(
                                                                        {
                                                                            inspectionViewModal: true
                                                                        }
                                                                    );
                                                                }}
                                                            >
                                                                Inspection View
                                                            </Button>
                                                            &nbsp;
                                                            &nbsp;
                                                            {template.profile.title === "Standard Vehicle Inspection"
                                                                ? ""
                                                                :
                                                                this.props.canDelete === true ?
                                                                    <IconButton
                                                                        style={{
                                                                            color: "red",
                                                                            paddingBottom: "10px",
                                                                            float: "right",

                                                                        }}
                                                                        onClick={() => {
                                                                            this.props.getCopyTemplate(template.profile.title, "inspection_checklist_templates")
                                                                            this.setState(
                                                                                {
                                                                                    template_details: template.profile,
                                                                                    deleteTemplateModal: true
                                                                                }
                                                                            );

                                                                        }}
                                                                    >
                                                                        <DeleteIcon />
                                                                    </IconButton>
                                                                    :
                                                                    ""
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </StyledListItem>
                                        );
                                    })}
                            </List>
                        </>
                        :
                        ""
                    }


                    {this.state.isTemplateCreate === true ?
                        <>
                            <br />
                            <br />
                            <Card>
                                <StyledHeader>
                                    <Typography variant="h5">
                                        Template Details
                                    </Typography>
                                </StyledHeader>
                                <StyledContent>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{ width: "60%", float: "left" }}
                                        >
                                            <div
                                                style={gstyle(5, 13, null, color)}
                                            >
                                                <div
                                                    style={cstyle(
                                                        1,
                                                        1,
                                                        1,
                                                        13,
                                                        false,
                                                        true
                                                    )}
                                                >
                                                    <b>Details</b>
                                                </div>
                                                <div style={cstyle(2, 1, 2, 13)}>
                                                    <b>Template Name <font color="red">*</font>:</b>
                                                </div>
                                                <div style={cstyle(2, 7, 2, 13)}>
                                                    {this.state.isTitleEntered === false ?
                                                        <>
                                                            <TextField
                                                                id="title"
                                                                multiline={false}
                                                                style={{ width: "250px" }}
                                                                value={
                                                                    this.state.template_details.title
                                                                }
                                                                onChange={event => {
                                                                    if (
                                                                        tempTitles.includes(event.target.value) === true
                                                                    ) {
                                                                        this.setState({
                                                                            warningModal: true,
                                                                        });
                                                                    }
                                                                    let templateTitle = this.state
                                                                        .template_details;
                                                                    templateTitle.title = event.target.value;
                                                                    this.setState({
                                                                        template_details: templateTitle
                                                                    });
                                                                }}
                                                            />
                                                        </>
                                                        :
                                                        <>
                                                            <span>
                                                                <TextField
                                                                    id="title"
                                                                    multiline={false}
                                                                    style={{ width: "250px", pointerEvents: "none" }}
                                                                    value={
                                                                        this.state.template_details.title
                                                                    }
                                                                    onChange={event => {
                                                                        if (
                                                                            tempTitles.includes(event.target.value) === true
                                                                        ) {
                                                                            this.setState({
                                                                                warningModal: true,
                                                                            });
                                                                        }
                                                                        let templateTitle = this.state
                                                                            .template_details;
                                                                        templateTitle.title = event.target.value;
                                                                        this.setState({
                                                                            template_details: templateTitle
                                                                        });
                                                                    }}
                                                                />
                                                            </span>
                                                            <span>
                                                                <IconButton
                                                                    style={{
                                                                        color: "#0188cc",
                                                                        border: "1px solid #0188cc",
                                                                        marginLeft: "70px",
                                                                        float: "right",
                                                                        marginTop: "0px"
                                                                    }}
                                                                    onClick={() => {
                                                                        this.props.getCopyTemplate(this.state.template_details.title, "inspection_templates_archieve")
                                                                        this.setState({
                                                                            titleChangeModal: true,
                                                                            prevTitleName: this.state.template_details.title
                                                                        })
                                                                    }}
                                                                >
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </span>
                                                        </>
                                                    }
                                                </div>
                                                <br />

                                            </div>
                                        </div>
                                    </div>
                                </StyledContent>
                                <Button
                                    style={{
                                        width: "250px",
                                        // float: "right",
                                        backgroundColor: "#0188cc",
                                        marginLeft: "10px",
                                        marginBottom: "24px"
                                    }}
                                    disabled={
                                        this.state.template_details.title === ""
                                            ? true
                                            : false
                                    }
                                    onClick={() => {
                                        if (
                                            archieveTitles.includes(this.state.template_details.title) === true
                                        ) {
                                            this.props.removeTemplate(this.state.template_details.title, "inspection_templates_archieve")
                                            let newGroup = this.state
                                                .created_by;
                                            newGroup.user_uid = uid;
                                            newGroup.user_name = name
                                            this.setState({
                                                created_by: newGroup
                                            });
                                            this.setState({
                                                isSection2: true,
                                                isTitleEntered: true
                                            })
                                            this.props.setReportDetails(
                                                this.state.template_details,
                                                this.state.created_by,
                                            )
                                            this.props.getInspections(this.state.template_details.title, "inspection_templates_archieve")
                                        }
                                        else {
                                            let newGroup = this.state
                                                .created_by;
                                            newGroup.user_uid = uid;
                                            newGroup.user_name = name
                                            this.setState({
                                                created_by: newGroup
                                            });
                                            this.setState({
                                                isSection2: true,
                                                isTitleEntered: true
                                            })
                                            this.props.setReportDetails(
                                                this.state.template_details,
                                                this.state.created_by,
                                            )
                                            this.props.getInspections(this.state.template_details.title, "inspection_templates_archieve")
                                        }
                                    }}
                                >
                                    <b style={{ color: "white" }}>Create</b>
                                </Button>
                                <Button

                                    onClick={() => {
                                        this.handleCloseModel();
                                    }}
                                    style={{
                                        width: "150px",
                                        // float: "right",
                                        backgroundColor: "#a9a5a5",
                                        marginLeft: "5px",
                                        marginBottom: "24px"
                                    }}
                                >
                                    Cancel
                                    </Button>
                            </Card>
                        </>
                        :
                        ""
                    }
                    {/* -----------Template Creation Part------------------------ */}
                    {this.state.isTemplateCreate === true && this.state.isSection2 === true ?
                        <>
                            <br />
                            <br />
                            <Card>
                                <StyledHeader>
                                    <Typography variant="h5">
                                        Inspection Sections
                                    </Typography>
                                </StyledHeader>
                                <StyledContent>
                                    <div>
                                        <Table>
                                            <TableBody>
                                                {inspections && inspections.map((e, i) => {
                                                    return (
                                                        <TableRow key={i}>

                                                            <div className="icon-text-container" style={{ borderWidth: "medium", border: "7px solid #0188cc", borderRadius: "9px", marginTop: "22px" }} >
                                                                <div className="float-left text-container" style={{ display: "flex", width: "100%", background: "#0288CC", color: "white" }}>
                                                                    <div >
                                                                        <h5 style={{ width: "max-content", marginTop: "17px", marginLeft: "7px" }}>{e.profile.title}</h5><br />
                                                                        <h5 style={{ width: "100%", marginTop: "-27px", marginLeft: "7px", fontWeight: "bold" }}>Section Items - {e.items && e.items.length !== 0 ? e.items.length : 0}</h5>
                                                                    </div>
                                                                    <div style={{ float: "right", width: "86%" }}>
                                                                        <div>
                                                                            <IconButton
                                                                                style={{
                                                                                    color: "black",
                                                                                    float: "right",
                                                                                    marginTop: "5px",
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        editUID:
                                                                                            e.profile.section_id,
                                                                                        new_group: e.profile,
                                                                                        editGroupModal: true
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <EditIcon />
                                                                            </IconButton>
                                                                        </div>
                                                                        <div>
                                                                            <IconButton
                                                                                style={{
                                                                                    color: "black",
                                                                                    float: "right",
                                                                                    marginTop: "5px",
                                                                                    margingLeft: "-11px"
                                                                                }}
                                                                                onClick={() => {
                                                                                    this.setState({
                                                                                        editUID:
                                                                                            e.profile.section_id,
                                                                                        new_group: e.profile,
                                                                                        deleteGroupModal: true
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <DeleteIcon />
                                                                            </IconButton>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div>
                                                                    <Table>
                                                                        <TableBody>
                                                                            {e.items && e.items.map((k, j) => {
                                                                                return (
                                                                                    <TableRow key={j}>

                                                                                        <div className="icon-text-container"  >
                                                                                            <div className="float-left text-container" style={{ display: "flex" }}>
                                                                                                <div style={{ float: "left" }}>
                                                                                                    {k.item_icon === "" ?
                                                                                                        <img style={{ height: "60px", width: "60px", marginTop: "12px", marginLeft: "5px" }} alt="tagicon" className="customNameImgStyle" src={require("./icons/custom_inspection_check_icon.png")} />
                                                                                                        :
                                                                                                        <img style={{ height: "60px", width: "60px", marginTop: "12px", marginLeft: "5px" }} alt="tagicon" className="customNameImgStyle" src={k.item_icon} />
                                                                                                    }
                                                                                                </div>
                                                                                                <div style={{ color: "#0188cc", marginTop: "24px", maxWidth: "63%", marginLeft: "24px", fontSize: "20px" }}>
                                                                                                    <p style={{ maxWidth: "105%" }}>{k.item_title}</p>
                                                                                                </div>
                                                                                                <div>
                                                                                                    <IconButton
                                                                                                        style={{
                                                                                                            color: "black",
                                                                                                            float: "right",
                                                                                                            marginTop: "15px",
                                                                                                            width: "86%",
                                                                                                            marginLeft: "66px"
                                                                                                        }}
                                                                                                        onClick={() => {
                                                                                                            this.setState({
                                                                                                                editUID:
                                                                                                                    e.profile.section_id,
                                                                                                                new_item: k,
                                                                                                                editItemModal: true,
                                                                                                            });

                                                                                                        }}
                                                                                                    >
                                                                                                        <EditIcon />
                                                                                                    </IconButton>
                                                                                                </div>
                                                                                            </div>
                                                                                            <Divider />
                                                                                            <div className="clear"></div>
                                                                                        </div>
                                                                                    </TableRow>
                                                                                );

                                                                            })}
                                                                        </TableBody>
                                                                    </Table>
                                                                </div>
                                                                {e.profile.section_id === this.state.groupIdReference - 1 ?
                                                                    <div>
                                                                        <IconButton
                                                                            style={{
                                                                                color: "black",
                                                                                marginLeft: "50%",

                                                                            }}
                                                                            disabled={
                                                                                e.profile.section_id === this.state.groupIdReference - 1
                                                                                    ? false
                                                                                    : true
                                                                            }
                                                                            onClick={() => {
                                                                                this.setState(
                                                                                    {
                                                                                        itemAddGroupName: e.profile.title,
                                                                                        itemAddGroupId: e.profile.section_id,
                                                                                        uploadImageLocal: false,
                                                                                        newItemModal: true
                                                                                    }
                                                                                );

                                                                            }}
                                                                        >
                                                                            <AddCircleIcon style={{ height: "35px", width: "50px" }} />
                                                                        </IconButton>
                                                                    </div>
                                                                    :
                                                                    ""
                                                                }
                                                                <div className="clear"></div>
                                                            </div>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </div>


                                    {this.state.groupcount === 0 ?
                                        <Button
                                            onClick={() => {
                                                this.handleNewInspectionModal();
                                            }}
                                            style={{ backgroundColor: "#0188CC", color: "white", marginTop: "16px" }}
                                            variant="contained"
                                        >
                                            Add Section <font color="red" style={{ fontSize: "20px" }}>*</font>
                                        </Button>
                                        :
                                        <Button
                                            onClick={() => {
                                                this.handleNewInspectionModal();
                                            }}
                                            disabled={
                                                this.state.itemcount === 0
                                                    ? true
                                                    : false
                                            }
                                            style={{ backgroundColor: "#0188CC", color: "white", marginTop: "16px" }}
                                            variant="contained"
                                        >
                                            Add Section <font color="red" style={{ fontSize: "20px" }}>*</font>
                                        </Button>

                                    }
                                </StyledContent>
                                <br />
                                <br />
                                <br />
                                <Button
                                    style={{
                                        width: "150px",
                                        float: "right",
                                        backgroundColor: "#0188cc",
                                        marginRight: "17px",
                                        marginBottom: "24px"
                                    }}
                                    disabled={
                                        this.state.itemcount === 0
                                            ? true
                                            : false
                                    }
                                    onClick={() => {
                                        this.props.getCopyTemplate(this.state.template_details.title, "inspection_templates_archieve")
                                        this.setState(
                                            {
                                                submitModal: true
                                            }
                                        );
                                    }}
                                >
                                    <b style={{ color: "white" }}>Submit</b>
                                </Button>
                                <Button

                                    onClick={() => {
                                        this.handleCloseModel();
                                        this.props.removeTemplate(this.state.template_details.title, "inspection_templates_archieve")
                                    }}
                                    style={{
                                        width: "150px",
                                        float: "right",
                                        backgroundColor: "#a9a5a5",
                                        marginRight: "20px",
                                        marginBottom: "24px"
                                    }}
                                >
                                    Cancel
                                    </Button>
                            </Card>
                        </>
                        :
                        ""
                    }
                    {/* --------------------------------------Add Inspection Modal---------------------------- */}
                    <div>
                        <Modal
                            isOpen={this.state.newInspectionModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Add Section
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Section Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%"
                                                }}
                                                value={
                                                    this.state.new_group.title
                                                }
                                                placeholder="Section Name"
                                                onChange={event => {
                                                    let newGroup = this.state
                                                        .new_group;
                                                    newGroup.title =
                                                        event.target.value;
                                                    this.setState({
                                                        new_group: newGroup
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                newInspectionModal: false,
                                                title: "",
                                                section_id: ""
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "#0188CC", color: "white" }}
                                        onClick={() => {
                                            this.handleCount("add", this.state.groupIdReference)
                                            this.setId(this.state.groupIdReference)
                                            this.props.addGroup(this.state.new_group, this.state.groupIdReference, this.state.template_details.title)
                                            this.props.getInspections(this.state.template_details.title, "inspection_templates_archieve")
                                            this.setState({
                                                newInspectionModal: false,
                                                title: "",
                                                section_id: "",
                                                groupcount: 100,
                                                itemcount: 0,
                                                itemIdReference: 0
                                            });
                                        }}
                                        disabled={
                                            this.state.new_group.title === ""
                                                ? true
                                                : false
                                        }
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>

                    {/* --------------------------------------Edit Inspection Modal---------------------------- */}
                    <div>
                        <Modal
                            isOpen={this.state.editGroupModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Edit Section
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Section Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                    maxWidth: "52%"
                                                }}
                                                value={
                                                    this.state.new_group
                                                        .title
                                                }
                                                placeholder="Section Name"
                                                onChange={event => {
                                                    let newGroup = this.state
                                                        .new_group;
                                                    newGroup.title =
                                                        event.target.value;
                                                    this.setState({
                                                        new_group: newGroup
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {

                                            this.setState({
                                                editGroupModal: false,
                                                title: "",
                                                section_id: "",
                                                editUID: ""
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "#0188CC", color: "white" }}
                                        disabled={
                                            this.state.new_group.title === ""
                                                ? true
                                                : false
                                        }
                                        onClick={() => {
                                            this.props.editGroup(this.state.new_group, this.state.editUID, this.state.template_details.title)
                                            this.props.getInspections(this.state.template_details.title, "inspection_templates_archieve")
                                            this.setState({
                                                editGroupModal: false,
                                                title: "",
                                                section_id: "",
                                                editUID: ""
                                            });
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>

                    {/* -----------------------------------Add Item Modal---------------------------- */}
                    <div>
                        <Modal
                            isOpen={this.state.newItemModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Add Items to the Section
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Section Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <span
                                                style={{ fontWeight: "bold" }}
                                            >
                                                <p>
                                                    {
                                                        this.state.itemAddGroupName
                                                    }
                                                </p>
                                            </span>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Item Name&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%"
                                                }}
                                                value={
                                                    this.state.new_item
                                                        .item_title
                                                }
                                                placeholder="Item Name"
                                                onChange={event => {
                                                    let newItem = this.state
                                                        .new_item;
                                                    newItem.item_title =
                                                        event.target.value;
                                                    this.setState({
                                                        new_item: newItem
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <ModalBody>
                                            <StyledAvatar
                                                style={{}}
                                                src={
                                                    this.state.uploadImageLocal
                                                        ? this.state.uploadImageLocal
                                                        : noImg
                                                }
                                                alt="Profile Image"
                                            />
                                        </ModalBody>
                                        <ModalBody>
                                            <input
                                                type="file"
                                                id="file"
                                                accept="image/*"
                                                ref="imageUploader"
                                                style={{ display: "none" }}
                                                onChange={event => {
                                                    if (event.target.files[0].size > 1000000) {
                                                        this.setState({ fileMaxSizeSnackbar: true });
                                                    } else {
                                                        refItem = {
                                                            ...this.state.new_item,
                                                            item_icon: event.target.files[0]
                                                        };
                                                        this.setState({
                                                            new_item: refItem,
                                                            uploadImageLocal: URL.createObjectURL(
                                                                event.target.files[0]
                                                            )
                                                        });

                                                    }
                                                }}
                                            />
                                            <Typography variant="body2">Add Item Icon</Typography>
                                            <IconButton
                                                onClick={() => {
                                                    this.refs.imageUploader.click();
                                                }}
                                                style={{
                                                    margin: "inherit",
                                                    color: "green",
                                                    border: "1px solid green"
                                                }}
                                            >
                                                <AddIcon />
                                            </IconButton>
                                            <Typography style={{ margin: "inherit" }} variant="body2">
                                                {"(< 1MB)"}
                                            </Typography>
                                        </ModalBody>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                new_item: {
                                                    item_title: "",
                                                    item_id: "",
                                                    item_icon: ""
                                                },
                                                itemAddGroupId: "",
                                                itemAddGroupName: "",
                                                newItemModal: false,
                                                uploadImageLocal: false
                                            });
                                        }}

                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "#0188CC", color: "white" }}
                                        disabled={
                                            this.state.new_item.item_title === ""
                                                ? true
                                                : false
                                        }
                                        onClick={() => {
                                            this.handleItemCount("add", this.state.itemIdReference)
                                            this.setItemId(this.state.itemIdReference, this.state.new_item)
                                            this.props.addItem(this.state.new_item, this.state.itemIdReference, this.state.itemAddGroupId, this.state.template_details.title)
                                            // this.props.getInspections(this.state.template_details.title)
                                            this.setState({
                                                itemcount: 100,
                                                itemAddGroupId: "",
                                                itemAddGroupName: "",
                                                newItemModal: false,
                                                uploadImageLocal: false,
                                                new_item: {
                                                    item_title: "",
                                                    item_id: "",
                                                    item_icon: ""
                                                },
                                            });
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>

                    {/* --------------------------------------Edit Item Modal---------------------------- */}
                    <div>
                        <Modal
                            isOpen={this.state.editItemModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Edit Item
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                &nbsp;Item Title&nbsp;:&nbsp;&nbsp;
                                            </Label>
                                            <TextField
                                                multiline={false}
                                                style={{
                                                    border: "2px solid #0188cc",
                                                    borderRadius: "9px",
                                                    marginBottom: "11px",
                                                    width: "100%",
                                                    maxWidth: "52%"
                                                }}
                                                value={
                                                    this.state.new_item
                                                        .item_title
                                                }
                                                placeholder="Item Name"
                                                onChange={event => {
                                                    let newItem = this.state
                                                        .new_item;
                                                    newItem.item_title =
                                                        event.target.value;
                                                    this.setState({
                                                        new_item: newItem
                                                    });
                                                }}
                                            />
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <ModalBody>
                                            <StyledAvatar
                                                style={{}}
                                                src={
                                                    this.state.uploadImageLocal
                                                        ? this.state.uploadImageLocal
                                                        : this.state.new_item.item_icon === ""
                                                            ? require("./icons/custom_inspection_check_icon.png")
                                                            : this.state.new_item.item_icon
                                                }
                                                alt="Profile Image"
                                            />
                                        </ModalBody>
                                        <ModalBody>
                                            <input
                                                type="file"
                                                id="file"
                                                accept="image/*"
                                                ref="imageUploader"
                                                style={{ display: "none" }}
                                                onChange={event => {
                                                    if (event.target.files[0].size > 1000000) {
                                                        this.setState({ fileMaxSizeSnackbar: true });
                                                    } else {
                                                        refItem = {
                                                            ...this.state.new_item,
                                                            item_icon: event.target.files[0]
                                                        };
                                                        this.setState({
                                                            new_item: refItem,
                                                            uploadImageLocal: URL.createObjectURL(
                                                                event.target.files[0]
                                                            )
                                                        });

                                                    }
                                                }}
                                            />
                                            <Typography variant="body2">Add Item Icon</Typography>
                                            <IconButton
                                                onClick={() => {
                                                    this.refs.imageUploader.click();
                                                }}
                                                style={{
                                                    margin: "inherit",
                                                    color: "green",
                                                    border: "1px solid green"
                                                }}
                                            >
                                                <AddIcon />
                                            </IconButton>
                                            <Typography style={{ margin: "inherit" }} variant="body2">
                                                {"(< 1MB)"}
                                            </Typography>
                                        </ModalBody>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({

                                                editItemModal: false,
                                                editUID: "",
                                                new_item: {
                                                    item_title: "",
                                                    item_id: "",
                                                    item_icon: ""
                                                },
                                            });
                                        }}

                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "#0188CC", color: "white" }}
                                        disabled={
                                            this.state.new_item.item_title === ""
                                                ? true
                                                : false
                                        }
                                        onClick={() => {
                                            this.props.editItem(this.state.new_item, this.state.editUID, this.state.new_item.item_id, this.state.template_details.title)
                                            this.props.editItemIcon(this.state.new_item, this.state.editUID, this.state.new_item.item_id, this.state.template_details.title)
                                            this.props.getInspections(this.state.template_details.title, "inspection_templates_archieve")
                                            this.setState({
                                                editItemModal: false,
                                                editUID: "",
                                                new_item: {
                                                    item_title: "",
                                                    item_id: "",
                                                    item_icon: ""
                                                }
                                            });
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* ----------------------------------------Archieve Template Modal ----------------------- */}
                    <div>
                        <Modal
                            isOpen={this.state.deleteTemplateModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Remove Template
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <p><b>Are you sure you want to delete this Inspection Template?</b></p>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Template Name&nbsp;:&nbsp;&nbsp; <b>{this.state.template_details.title}</b>
                                            </Label>

                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                deleteTemplateModal: false,
                                            });
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "red", color: "white" }}
                                        onClick={() => {
                                            this.setState({
                                                deleteTemplateModal: false,

                                            });
                                            this.props.templateCopy(this.state.template_details.title, copyTemp, this.state.created_by, "inspection_templates_archieve")
                                            this.props.removeTemplate(this.state.template_details.title, "inspection_checklist_templates")
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* ----------------------------------------Submit Template Modal ----------------------- */}
                    <div>
                        <Modal
                            isOpen={this.state.submitModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Confirm Template
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <p>On Submit <b>{this.state.template_details.title}</b> Walkaround Inspection template will be Created </p>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Template Name&nbsp;:&nbsp;&nbsp; <b>{this.state.template_details.title}</b>
                                            </Label>

                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                submitModal: false,
                                            });
                                            this.handleCloseModel();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "primary", color: "white" }}
                                        onClick={() => {
                                            this.props.templateCopy(this.state.template_details.title, copyTemp, this.state.created_by, "inspection_checklist_templates")
                                            this.props.removeTemplate(this.state.template_details.title, "inspection_templates_archieve")
                                            let reportTitle = this.state
                                                .template_details;
                                            reportTitle.deleted = false;
                                            reportTitle.timestamp = moment().format("DD-MM-YYYY HH:mm:ss");
                                            this.setState({
                                                report_details: reportTitle
                                            });
                                            this.props.setDeleted(
                                                this.state.template_details,
                                                error => {
                                                    if (!error) {
                                                        this.handleCloseModel();
                                                        return null
                                                    }
                                                    else {
                                                        return null
                                                    }
                                                }
                                            )
                                            this.setState({
                                                submitModal: false,

                                            });
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* // ------------------------View inspectionViewModal Modal ---------------- */}
                    <InfoModal
                        isOpen={this.state.inspectionViewModal}
                        style={{ width: "117%" }}
                    >
                        <InfoPaper>
                            <StyledCard>
                                <StyledHeader>
                                    <Typography
                                        variant="headline"
                                        style={{
                                            textAlign: "center",
                                            fontSize: "1.2em",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        Inspection Details
                                    </Typography>
                                </StyledHeader>
                            </StyledCard>
                            {/* <p
                                style={{
                                    textAlign: "center",
                                    backgroundColor: "#0188CC",
                                    paddingTop: "4px",
                                    paddingBottom: "4px",
                                    fontWeight: "bold",
                                    color:"white"
                                }}
                            >
                                Inspection Details
                            </p> */}
                            <InfoDiv>
                                <Table>
                                    <TableBody>
                                        {inspections && inspections.map((e, i) => {
                                            return (
                                                <TableRow key={i}>

                                                    <div className="icon-text-container" style={{ borderWidth: "medium", border: "4px solid #0188cc", borderRadius: "9px", marginTop: "15px", width: "455px" }} >
                                                        <div className="float-left text-container" style={{ display: "flex", width: "100%" }}>
                                                            <span>
                                                                <h5 style={{ width: "100%", marginTop: "7px", marginLeft: "7px",color: "#0188cc" }}>Section Name: <span className="subHeading">{e.profile.title}</span></h5>
                                                            </span>

                                                        </div>
                                                        <div>
                                                            <Table>
                                                                <TableBody>
                                                                    {e.items && e.items.map((k, j) => {
                                                                        return (
                                                                            <TableRow key={j}>
                                                                                <div className="icon-text-container"  >
                                                                                    <div className="float-left text-container" style={{ display: "flex" }}>
                                                                                        <span>
                                                                                            {k.item_icon === "" ?
                                                                                            <div style={{display:"flex", marginTop:"5px", marginBottom:"5px"}}>
                                                                                                <div><img style={{ height: "46px", width: "60px", marginLeft:"5px" }} alt="tagicon" className="customNameImgStyle" src={require("./icons/custom_inspection_check_icon.png")} /> </div><div style={{fontSize:"16px", paddingLeft:"16px", paddingTop:"7px"}}> {k.item_title}</div>
                                                                                            </div>   
                                                                                                :
                                                                                            <div style={{display:"flex", marginTop:"5px", marginBottom:"5px"}}>
                                                                                               <div> <img style={{ height: "46px", width: "60px", marginLeft:"5px" }} alt="tagicon" className="customNameImgStyle" src={k.item_icon} /> </div><div style={{fontSize:"16px", paddingLeft:"16px", paddingTop:"7px"}}>{k.item_title}</div>
                                                                                            </div>
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                    <div className="clear"></div>
                                                                                </div>
                                                                            </TableRow>
                                                                        );
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </div>
                                                        <div className="clear"></div>
                                                    </div>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </InfoDiv>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    this.handleCloseModel();
                                }}
                                style={{
                                    float: "right",
                                    marginLeft: "5%",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                    marginRight: "10px",
                                    backgroundColor: "#0188cc",
                                    color: "white",
                                }}
                            >
                                Cancel
                            </Button>
                        </InfoPaper>
                    </InfoModal>
                    {/* --------------------------------------Delete Inspection Modal---------------------------- */}
                    <div>
                        <Modal
                            isOpen={this.state.deleteGroupModal}
                        >
                            <StyledHeader>
                                <Typography variant="h5">
                                    Delete Section
                                </Typography>
                            </StyledHeader>
                            <StyledContent>
                                <ModalBody>
                                    <ModalRow>
                                        <Col>
                                            <p><b>Are you sure you want to delete this section from Inspection?</b></p>
                                        </Col>
                                    </ModalRow>
                                    <ModalRow>
                                        <Col>
                                            <Label for="name">
                                                Section Name&nbsp;:&nbsp;&nbsp; <b>{this.state.new_group.title}</b>
                                            </Label>
                                        </Col>
                                    </ModalRow>
                                </ModalBody>
                            </StyledContent>
                            <ModalFooter>
                                <div>
                                    <Button
                                        onClick={() => {
                                            this.setState({
                                                deleteGroupModal: false,
                                                title: "",
                                                section_id: "",
                                                editUID: ""
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        style={{ backgroundColor: "#0188CC", color: "white" }}
                                        onClick={() => {

                                            this.props.removeGroup(this.state.editUID, this.state.template_details.title)
                                            this.props.getInspections(this.state.template_details.title, "inspection_templates_archieve")
                                            this.setState({
                                                deleteGroupModal: false,
                                                title: "",
                                                section_id: "",
                                                editUID: ""
                                            });
                                        }}
                                    >
                                        Delete
                                    </Button>
                                </div>
                            </ModalFooter>
                        </Modal>
                    </div>
                    {/* ------------------------------Warning Modal--------------------------- */}
                    <Modal isOpen={this.state.warningModal}>
                        <ModalHeader style={{ color: "red" }}>Warning!!!</ModalHeader>
                        <ModalBody>
                            <b>Template name already exists</b>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    this.setState({
                                        warningModal: false,
                                        template_details: {
                                            title: "",
                                            deleted: true,
                                            timestamp: "",
                                        },
                                        newCopyName: ""
                                    });
                                }}
                            >
                                Cancel
                        </Button>
                        </ModalFooter>
                    </Modal>

                    {/* ------------------------------Name CHange Modal--------------------------- */}
                    <Modal isOpen={this.state.titleChangeModal}>
                        <ModalHeader style={{ color: "red" }}>Change Title </ModalHeader>
                        <ModalBody>
                            <Label for="name">
                                Edit Template Name&nbsp;:&nbsp;&nbsp;
                            </Label>
                            <TextField
                                multiline={false}
                                style={{
                                    marginBottom: "11px",
                                    width: "100%"
                                }}
                                value={
                                    this.state.copyTitleName
                                }
                                placeholder="Section Name"
                                onChange={event => {
                                    if (
                                        tempTitles.includes(event.target.value) === true
                                    ) {
                                        this.setState({
                                            warningModal: true,
                                        });
                                    }
                                    let newName = event.target.value;
                                    this.setState({
                                        copyTitleName: newName
                                    });
                                }}
                            />
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                disabled={this.state.copyTitleName === "" ?
                                    true
                                    :
                                    false
                                }
                                onClick={() => {
                                    let newGroup = this.state.template_details;
                                    newGroup.title = this.state.copyTitleName;
                                    this.setState({
                                        template_details: newGroup
                                    });

                                    this.props.templateCopy(this.state.copyTitleName, copyTemp, this.state.created_by, "inspection_templates_archieve")
                                    this.props.removeTemplate(this.state.prevTitleName, "inspection_templates_archieve")
                                    this.props.getInspections(this.state.copyTitleName, "inspection_templates_archieve")
                                    this.setState({
                                        titleChangeModal: false,
                                        isTitleEntered: true,
                                        copyTitleName: "",
                                        prevTitleName: ""
                                    })
                                }}
                                style={{
                                    width: "100%",
                                    backgroundColor: "#0288CC",
                                    marginLeft: "5px",
                                    marginBottom: "24px",
                                    color: "white"
                                }}
                            >
                                Edit
                            </Button>
                            <Button

                                onClick={() => {
                                    this.setState({
                                        titleChangeModal: false,
                                        isTitleEntered: true,
                                        copyTitleName: "",
                                        prevTitleName: ""
                                    })
                                }}
                                style={{
                                    width: "100%",
                                    backgroundColor: "#a9a5a5",
                                    marginLeft: "5px",
                                    marginBottom: "24px"
                                }}
                            >
                                Cancel
                                    </Button>
                        </ModalFooter>
                    </Modal>
                </StyledContent>
            </StyledCard>
        );
    }
}

export default connect(
    (store) => {
        return {
            templates: selectTemplate(store),
            inspections: getCustomInspections(store),
            userProfile: getUserProfile(store),
            tempTitles: selectTemplateName(store),
            archieveTitles: selectArchieveTemplateName(store),
            copyTemp: getSelectedTemplate(store),
            canUpdate: canUpdate(store),
            canCreate: canCreate(store),
            canDelete: canDelete(store),
        };
    },
    {
        getFeatures,
        setReportDetails,
        getTemplates,
        addGroup,
        getInspections,
        setDeleted,
        removeTemplate,
        addItem,
        editGroup,
        removeGroup,
        editItem,
        editItemIcon,
        getCopyTemplate,
        templateCopy,
        getArchieveTemplates
    }
)(withStyles(styles)(VehicleChecklistTemplate));
